const localStorageConstants = {
  channelUrl: 'channelUrl', // should this be renamed to sendbirdChannelUrl?
  inquiryASFilter: 'inquiryASFilter',
  inquiryPSRFilter: 'inquiryPSRFilter',
  inquiryView: 'inquiryView',
  intent: 'intent', // is this like a post-login navigation intent?
  patientColumnFilter: 'patientColumnFilter',
  patientColumnSortOrder: 'patientColumnSortOrder',
  patientDocumentPageCount: 'patientDocumentPageCount',
  patientFilter: 'patientFilter',
  patientPageCount: 'patientPageCount',
  providerDashboardFilter: 'providerDashboardFilter',
  taskFilter: 'taskFilter',
  taskOrganizeBy: 'taskOrganizeBy',
  userPageCount: 'userPageCount',
};

export default localStorageConstants;
